import {
    createAsyncThunk
} from '@reduxjs/toolkit';
import axios from 'axios';
import {
    api
} from '../../helpers/api_helper';
import { API_ENDPOINTS } from '../../constants/apiEndPoints';



export const getMobileData = createAsyncThunk(
    'mobileView/dashboard',
    async (thunkAPI) => {
        try {
            const url = API_ENDPOINTS.MOBILE_VIEW.DASHBOARD;
            const response = await api.get(url);
            // Log('getMobileData' , 'info' , response.data)
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const getMobileListingData = createAsyncThunk(
    'mobileView/listing',
    async ( thunkAPI) => {
        try {
            const url =  API_ENDPOINTS.MOBILE_VIEW.LISTING;
            const response = await api.get(url);
            // Log('getMobileListingData' , response.data)
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);